<template>
          
    <div class="ticketrecord3">
        <label class="text subtitle ticketfield" for >{{toDate(ticket.startDateTime)}}</label>
        <label class="text subtitle ticketfield" for>{{getGuestName}}</label>
        <label class="text subtitle ticketfield leftjustify" for>{{ticket.productServiceName}}</label>
        <label class="text subtitle ticketfield leftjustify" for>{{ticket.employeeName}}</label>
        <label class="text subtitle ticketfield rightjustify" for>$ {{ticket.total}}</label>
        <label class="text subtitle ticketfield leftjustify" for>{{ticket.statusName}}</label>

        <div class="linkdiv2 horizFlex">
            <confirm  :showLink="trueParam" :body="getRemoveString(ticket.guestName)" title="Void Ticket" @yes="checkprocess_terminaltest(ticket.id)" v-if="isvoidable"/>
            <linkbutton toplabel="Receipt" @click="getReceiptData(ticket.id)"/>
            <linkbutton toplabel="Go to Ticket" @click="goticket()"/>
        </div>
        
    </div>
                            
</template>
    
    <script>
    import format from '../../style/format.js'
    import ticketdetail from '../actions/ticketdetail.vue'
     import confirm from '../actions/confirm.vue'
     import linkbutton from '../controls/linkbutton.vue'
    export default {
        name:'ticketh',
        
        props:{
           
            ticket:{
                type:Object,
                default:null
            },

            
        },
        components:{
            linkbutton,
            confirm,
            ticketdetail
        },
        mixins:[format],
       
        data(){
            return{
              trueParam:true
            }
        },
        computed:{
            getGuestName(){
                var name=null
                console.log('gname ' + this.ticket.guestName)
                if(this.ticket.TakeOutGuestName!=null){return this.ticket.TakeOutGuestName}
                else if(this.ticket.guestName!=null && !this.ticket.guestName.includes('T:')){name= this.ticket.guestName}
                
                if(this.ticket.TableNumber!=null){
                    if(this.ticket.TableNumber>0){
                        if(name==null){name='Table ' + this.ticket.TableNumber} 
                        else{name = name + '/' + 'Table ' + this.ticket.TableNumber}
                    }
                    
                }
                return name
            },
            isvoidable(){
                return this.ticket.statusName=='CheckedOut' && this.ticket.total >0
            },
        },
        methods:{
            toDate(dt){
                return this.$options.filters.formatTime(dt);
            },
             
           getReceiptData(){

           },
           goticket(){
            this.$emit('gototicket')
           },
            getRemoveString(name){
                    return 'Do you want to void the ticket for ' + name + '?'
            },
            async Remove(ID){

            },
            checkprocess_terminaltest(ID){

            }
                
        },
        
    }
    
    </script>
    
    <style>
    .ticketrecord3{
        display:grid;
        grid-template-columns: 1fr 3fr 3fr 3fr 1fr 2fr 3fr;
        border:1px solid gray;
        margin:5px;
    }
    .linkdiv2{
    padding:8px 8px 0px 8px;
}
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    